export default function getVariation(placement) {
  return placement.split('-')[1];
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/utils/getVariation.js
// module id = W2yE
// module chunks = 0